import clayFeatureToggles from "../../../images/agents/clay/feature-toggles.png";
import clayIntercomDocsCurator from "../../../images/agents/clay/intercom-docs-curator.png";
import clayProductionInvestigator from "../../../images/agents/clay/production-investigator.png";
import clayProductionObserver from "../../../images/agents/clay/production-observer.png";
import pixelFeatureToggles from "../../../images/agents/pixel/feature-toggles.png";
import pixelIntercomDocsCurator from "../../../images/agents/pixel/intercom-docs-curator.png";
import pixelProductionInvestigator from "../../../images/agents/pixel/production-investigator.png";
import pixelProductionObserver from "../../../images/agents/pixel/production-observer.png";

interface AgentIconSet {
  pixel: string;
  clay: string;
}

export interface AgentIconImage {
  src: string;
  pixelated: boolean;
}

const agentIconSets: Record<string, AgentIconSet> = {
  "production-investigator": { pixel: pixelProductionInvestigator, clay: clayProductionInvestigator },
  "production-observer": { pixel: pixelProductionObserver, clay: clayProductionObserver },
  "intercom-docs-curator": { pixel: pixelIntercomDocsCurator, clay: clayIntercomDocsCurator },
  "feature-toggles": { pixel: pixelFeatureToggles, clay: clayFeatureToggles },
};

export const getAgentIcon = (slug: string, date: Date): AgentIconImage | undefined => {
  const iconSet = agentIconSets[slug];
  if (!iconSet) {
    return undefined;
  }

  const isEvenDay = date.getDate() % 2 === 0;
  return isEvenDay ? { src: iconSet.pixel, pixelated: true } : { src: iconSet.clay, pixelated: false };
};
